import React, { useState } from 'react';
import Converter from 'ansi-to-html';

// Inizializza il convertitore (colori stile terminale scuro)
const convert = new Converter({
    fg: '#f1f5f9',
    bg: '#020617',
    newline: true,
    escapeXML: false,
    stream: false,

    colors: {
        0: '#000000', // Nero
        1: '#ef4444', // Rosso (Errori)
        2: '#22c55e', // Verde (Successi)
        3: '#f59e0b', // Giallo (Warning)
        4: '#3b82f6', // Blu
        5: '#a855f7', // Magenta
        6: '#06b6d4', // Cyan
        7: '#f1f5f9'  // Bianco
    }
});

export default function BotLogs() {
    const [logsHtml, setLogsHtml] = useState("");
    const [loading, setLoading] = useState(false);

    const fetchLogs = async () => {
        setLoading(true);
        try {
            const res = await fetch('/api/bot-logs');
            const data = await res.json();
            if (data.logs) {
                // Convertiamo le sequenze ANSI in HTML (es: <span> rossi/verdi)
                const html = convert.toHtml(data.logs);
                setLogsHtml(html);
            }
        } catch (err) {
            setLogsHtml("Errore nel caricamento.");
        }
        setLoading(false);
    };

    return (
        <div style={{ marginTop: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <h3 style={{ color: '#94a3b8', margin: 0, fontSize: '12px' }}>LIVE CONSOLE</h3>
                <button onClick={fetchLogs} style={btnStyle}>
                    {loading ? "..." : "Aggiorna"}
                </button>
            </div>
            
            {/* Usiamo dangerouslySetInnerHTML perché la libreria genera tag <span> per i colori */}
            <div 
                style={terminalStyle}
                dangerouslySetInnerHTML={{ __html: logsHtml || "Nessun log." }}
            />
        </div>
    );
}

const terminalStyle = {
    backgroundColor: '#020617',
    padding: '15px',
    borderRadius: '8px',
    fontFamily: "'Fira Code', monospace",
    fontSize: '12px',
    height: '300px',
    overflowY: 'auto',
    border: '1px solid #334155',
    lineHeight: '1.4'
};

const btnStyle = {
    padding: '4px 10px',
    backgroundColor: '#3b82f6',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '11px'
};